import { Suspense } from 'react';
import { Outlet, Route, Routes } from 'react-router-dom';

import { AnomalyDashboardPage } from '~/modules/marketing/pages/anomaly-dashboard/AnomalyDashboardPage';

import { DigitalCampaignPerformancePage } from '../pages/digital-campaign-performance/DigitalCampaignPerformancePage';
import { MarketingPage } from '../pages/MarketingPage/MarketingPage';

/**
 * Top-level router combining module-level routers
 */
export function Router() {
  return (
    <Suspense>
      <Routes>
        <Route element={<Outlet />}>
          <Route index element={<MarketingPage />} />
          <Route
            path="campaigns"
            element={<DigitalCampaignPerformancePage />}
          />
          <Route path="anomaly" element={<AnomalyDashboardPage />} />
        </Route>
      </Routes>
    </Suspense>
  );
}

Router.displayName = 'MarketingRouter';
